import { useCallback } from 'react'
import confetti from 'canvas-confetti'

interface SparkleOptions {
  origin?: { x: number; y: number }
  particleCount?: number
  spread?: number
  colors?: string[]
}

export function useSparkle() {
  const burst = useCallback((options: SparkleOptions = {}) => {
    const {
      origin = { x: 0.5, y: 0.5 },
      particleCount = 50,
      spread = 70,
      colors = ['#FFD700', '#FFA500', '#FF6B35', '#4ECDC4', '#06D6A0'],
    } = options

    confetti({
      particleCount,
      spread,
      origin,
      colors,
      disableForReducedMotion: true,
      gravity: 0.8,
      scalar: 1.2,
      drift: 0,
      ticks: 100,
    })
  }, [])

  const miniBurst = useCallback((x: number, y: number) => {
    confetti({
      particleCount: 15,
      spread: 40,
      origin: { x, y },
      colors: ['#FFD700', '#FFA500'],
      disableForReducedMotion: true,
      gravity: 1.2,
      scalar: 0.8,
      ticks: 60,
    })
  }, [])

  const celebration = useCallback(() => {
    const duration = 2000
    const end = Date.now() + duration

    const frame = () => {
      confetti({
        particleCount: 5,
        angle: 60,
        spread: 55,
        origin: { x: 0 },
        colors: ['#FFD700', '#FFA500', '#FF6B35'],
      })
      confetti({
        particleCount: 5,
        angle: 120,
        spread: 55,
        origin: { x: 1 },
        colors: ['#4ECDC4', '#06D6A0', '#45B7D1'],
      })

      if (Date.now() < end) {
        requestAnimationFrame(frame)
      }
    }

    frame()
  }, [])

  return {
    burst,
    miniBurst,
    celebration,
  }
}

export default useSparkle
